import axiosTokenInstance from 'services/api/backoffice';
import {
  FETCH_NEIGHBORHOOD_LOCATION,
  FETCH_NEIGHBORHOOD_LOCATION_ERROR,
} from '_models/redux/types';

// Action function
export const fetchNeighborhoodLocation = (params) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(`/api/sepomex/neighborhoods/${params}/location`);

    const { data, status } = response || {};

    dispatch({
      type: FETCH_NEIGHBORHOOD_LOCATION,
      payload: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: FETCH_NEIGHBORHOOD_LOCATION_ERROR,
      payload: e || {},
    });
  }
};
